export const getQueryParamValue = (name: string): string | undefined => {
  const searchParams = new URLSearchParams(window.location.search.substring(1));
  const result = searchParams.get(name);

  return result ?? undefined;
};
